// Small helpers to render human-friendly presence / last-seen info.

const STATUS_LABEL = { online: "Online", away: "Away", offline: "Offline" };

export function relativeTime(iso) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;
  const diff = Date.now() - then;
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min${mins === 1 ? "" : "s"} ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs === 1 ? "" : "s"} ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days} day${days === 1 ? "" : "s"} ago`;
  return new Date(iso).toLocaleDateString();
}

export function absoluteTime(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString();
}

// Build a compact multi-line tooltip string for a person (student/teacher).
export function presenceTooltip({ status, lastSeenAt, lastLoginAt } = {}) {
  const lines = [];
  if (status) lines.push(STATUS_LABEL[status] || "Offline");
  if (lastLoginAt) lines.push(`Last login: ${relativeTime(lastLoginAt)} (${absoluteTime(lastLoginAt)})`);
  else lines.push("Last login: never");
  if (lastSeenAt && status !== "online") lines.push(`Last seen: ${relativeTime(lastSeenAt)}`);
  return lines.join("\n");
}
